import * as Sentry from "@sentry/react";

export function ErrorButton() {
  return (
    <button
      className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 font-medium shadow transition-colors"
      onClick={() => {
        // Send a log before throwing the error
        Sentry.logger.info("User triggered test error", {
          action: "test_error_button_click",
        });
        // Send a test metric before throwing the error
        Sentry.metrics.count("test_counter", 1);
        throw new Error("This is your first error!");
      }}
    >
      Break the world
    </button>
  );
}

export default ErrorButton;
